import {useEffect, useState} from 'react';
import API from '../Services/API';
import State from './State';
import Model from './Model';

const getAssets = async (assetIds) => {
    return new Promise((resolve) => {
        const query = 'assetIds[]=' +assetIds.sort().join('&assetIds[]=');

        if (State.get(['assets', query])) {
            return resolve(State.get(['assets', query]));
        }

        API.get('/assets?' + query).then(as => {
            State.put(['assets', query], as);
            resolve(as);
        });
    });
}

const useAssets = (assetIds) => {
    const [assets, setAssets] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!assetIds) {
            setAssets([]);
            setIsLoading(false);
            return;
        }

        getAssets(assetIds).then(setAssets).finally(() => setIsLoading(false));
    }, [assetIds]);

    return {assets, isLoading};
}

const useAsset = (assetId) => {
    return Model({
        stateKey: ['asset', assetId],
        block: !assetId,
        fetchData: () => API.get(`/assets?assetIds[]=${assetId}`).then(assets => assets?.[0] || null),
        returnDataKey: 'asset',
        defaultLoadingError: 'Failed to load asset.',
        registerAdditionalMethods: (opts) => {
            return {
                resize: (dimensions) => {
                    if (!dimensions) {
                        return Promise.reject(new Error('Dimensions are required'));
                    }

                    return opts.wrapUpdateCall(
                        () => API.get(`/assets/${assetId}/resize?dimensions=${encodeURIComponent(dimensions)}`),
                        null,
                        true,
                        true,
                    );
                },
            }
        },
    });
}

export {
    getAssets,
    useAssets,
    useAsset,
};
